import { config } from '../utils/config';

export function friendly_token( token, limit )
{
  if ( token == null ) {
    return 'Certificato approvato, in pubblicazione';
  }

  let newToken = '';
  let len = limit;
  let counter = 0;
  for  ( let i = 0; i < token.length; i++ ) {
    if ( counter == len ) {
      newToken += ' - '+token[i];
      counter = 0;
    } else {
      newToken += token[i];
    }
    counter ++
  }
  return newToken;
}

export function parse_date ( date )
{
  let d = new Date( date );
  let nuDate = `${d.getDay()}/${d.getMonth()}/${d.getFullYear()}`;
  return nuDate;
}

export function get_euro_value ( val, change )
{
  let price = ( val / parseFloat(config.constants.ounce) ) / change ;
  return price;
}

export function to_euro ( price )
{
  return new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format(price);
}

export function get_now_time ()
{
  let time = new Date();
  return time.getTime();
}

export function get_time_passed ( startTime )
{
  let time = new Date();
  let nowTime = time.getTime();
  let diff = nowTime - startTime;
  return diff;
}

export function get_product_friendly_name ( name ) {
  switch ( name ) {
    default:
    case 'XAU':
      return 'AU';

    case 'XAG':
      return 'AG';
  }
}
